import addLevel from '../../components/hierarchy/addLevel.vue'
import editLevel from '../../components/hierarchy/editLevel.vue'
import deleteLevel from '../../components/hierarchy/deleteLevel.vue'
import store from '../../store/index'
export default {
  className: 'hierarchy',
  tableSize: 'small',
  render (data) {
    return data.name
  },
  fields: [
    'parent',
    {
      name: 'name',
      note: '层级名称'
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      // where.tag = {
      //   $regex: `^1-3-`
      // }
    }
  },
  action: {
    create: {
      type: 'treeNode',
      text: '',
      icon: 'plus-circle',
      // permission: 'createHierarchyModel',
      hidden: () => !store.getters.isAdmin,
      component: addLevel
    },
    edit: {
      type: 'treeNode',
      text: '',
      icon: 'edit',
      // permission: 'editHierarchyModel',
      hidden: () => !store.getters.isAdmin,
      component: editLevel
    },
    deletes: {
      type: 'treeNode',
      text: '',
      icon: 'delete',
      // permission: 'deleteHierarchyModel',
      hidden: () => !store.getters.isAdmin,
      component: deleteLevel
    }
    // accredit: {
    //   type: 'treeNode',
    //   text: '',
    //   icon: 'safety',
    //   // permission: 'editPermission',
    //   hidden: () => !store.getters.isAdmin,
    //   callback: async ({ vm, record }) => {
    //     vm.$router.push({ path: '/users/permission', query: { id: record.objectId } })
    //   }
    // }
  }
}
